<template>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.history_banner.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Banner</h5>
      <span v-if="this.history_banner.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="history_banner.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && history_banner.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('history_banner')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <Button @click="bannerButtonPreview" class="btn btn-light m-2">Preview
        </Button>
        <Button v-if="!isApprover && history_banner.approval !== 'Pending'" @click="bannerButtonDraft"
          class="btn btn-light m-2">Save Draft
        </Button>
        <Button v-if="!isApprover && history_banner.approval !== 'Pending'" @click="bannerButtonSubmit"
          class="btn btn-warning m-2">Submit For Approval
        </Button>
        <button v-if="isApprover && history_banner.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('history_banner')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.history_image.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">History Image</h5>
      <span v-if="this.history_image.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="history_image.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && history_image.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('history_image')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <Button @click="historyImagePreview" class="btn btn-light m-2">Preview
        </Button>
        <Button v-if="!isApprover && history_image.approval !== 'Pending'" @click="historyImageDraft"
          class="btn btn-light m-2">Save Draft
        </Button>
        <Button v-if="!isApprover && history_image.approval !== 'Pending'" @click="historyImageSubmit"
          class="btn btn-warning m-2">Submit For Approval
        </Button>
        <button v-if="isApprover && history_image.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('history_image')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.history_description.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">History</h5>
      <span v-if="this.history_description.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <ckeditor :editor="editor" v-model="history_description.description" :config="editorConfig"
        :disabled="isApprover || history_description.approval === 'Pending'">
      </ckeditor>

      <div class="float-right">
        <Button @click="historyPreview" class="btn btn-light m-2">Preview
        </Button>
        <Button v-if="!isApprover && history_description.approval !== 'Pending'" @click="historyDraft"
          class="btn btn-light m-2">Save Draft
        </Button>
        <Button v-if="!isApprover && history_description.approval !== 'Pending'" @click="historySubmit"
          class="btn btn-warning m-2">Submit For Approval
        </Button>
        <button v-if="isApprover && history_description.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('history_description')">
          Approval
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import DropFile from "@/components/DropFile.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    SmallButtonComponent,
    DropFile,
    FileUploadComponent,
    ckeditor: CKEditor.component,
    ImageComponent,
    ApprovalComponent,
  },

  data() {
    return {
      history_banner: [],
      history_image: [],
      history_description: [],
      isApprover: false,
      datas: [],

      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "|",
          "link",
          "blockQuote",
          "|",
          "bulletedList",
          "numberedList",
          "outdent",
          "indent",
          "undo",
          "redo",
        ],
        height: "100",
        line: "50",
      },
    };
  },

  methods: {
    async loadHistory() {
      try {
        let response = await getRequest("/about-us/create?section=3", true);

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }

        this.history_banner = response.data.data.history_banner;
        this.history_image = response.data.data.history_image;
        this.history_description = response.data.data.history_description;
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";

      this.$emit("history", {
        banner: this.history_banner,
        image: this.history_image,
      });
    },

    //Banner Section
    async bannerButtonPreview() {
      if (this.history_banner.approval == 'Pending' || (this.history_banner.approval == 'Approved' && this.isApprover)) {
        window.open("/history?preview=1");
      } else {
        let postData = {
          image: this.history_banner.gallery_id
            ? this.history_banner.gallery_id
            : this.history_banner.image_id,
          approval: false,
        };

        let response;
        if (this.history_banner.approval === "Draft") {
          response = await postRequest(
            "/histories/banner/" + this.history_banner.id,
            postData
          );
        } else {
          response = await postRequest("/histories/banner", postData);
        }

        if (response.data.success) {
          window.open("/history?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    bannerButtonDraft() {
      this.bannerSubmission(this.history_banner, 0);
    },
    bannerButtonSubmit() {
      this.bannerSubmission(this.history_banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;
        if (this.history_banner.approval === "Draft") {
          response = await postRequest(
            "/histories/banner/" + this.history_banner.id,
            post_request
          );
        } else {
          response = await postRequest("/histories/banner", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.history_banner.gallery_id
          ? this.history_banner.gallery_id
          : this.history_banner.image_id,
        status: 0,
      };
    },

    //History Image Section
    async historyImagePreview() {
      if (this.history_image.approval == 'Pending' || (this.history_image.approval == 'Approved' && this.isApprover)) {
        window.open("/history?preview=1");
      } else {
        let postData = {
          image: this.history_image.gallery_id
            ? this.history_image.gallery_id
            : this.history_image.image_id,
          approval: false,
        };

        let response;
        if (this.history_image.approval === "Draft") {
          response = await postRequest(
            "/histories/image/" + this.history_image.id,
            postData
          );
        } else {
          response = await postRequest("/histories/image", postData);
        }

        if (response.data.success) {
          window.open("/history?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    historyImageDraft() {
      this.historyImageSubmission(this.history_image, 0);
    },
    historyImageSubmit() {
      this.historyImageSubmission(this.history_image, 1);
    },

    async historyImageSubmission(data, approval) {
      try {
        let post_request = this._imageRequest(data);
        post_request.approval = approval;

        let response;
        if (this.history_image.approval === "Draft") {
          response = await postRequest(
            "/histories/image/" + this.history_image.id,
            post_request
          );
        } else {
          response = await postRequest("/histories/image", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _imageRequest(data) {
      return {
        image: this.history_image.gallery_id
          ? this.history_image.gallery_id
          : this.history_image.image_id,
        status: 0,
      };
    },

    //History Description Section
    async historyPreview() {
      if (this.history_description.approval == 'Pending' || (this.history_description.approval == 'Approved' && this.isApprover)) {
        window.open("/history?preview=1");
      } else {
        let postData = {
          description: this.history_description.description,
          approval: false,
        };

        let response;
        if (this.history_description.approval === "Draft") {
          response = await postRequest(
            `/histories/description/` + this.history_description.id,
            postData
          );
        } else {
          response = await postRequest(`/histories/description`, postData);
        }

        if (response.data.success) {
          window.open("/history?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    historyDraft() {
      this.descriptionSubmission(this.history_description, 0);
    },
    historySubmit() {
      this.descriptionSubmission(this.history_description, 1);
    },

    async descriptionSubmission(data, approval) {
      try {
        let post_request = this._desriptionRequest(data);
        post_request.approval = approval;

        let response;
        if (this.history_description.approval === "Draft") {
          response = await postRequest(
            `/histories/description/` + this.history_description.id,
            post_request
          );
        } else {
          response = await postRequest(`/histories/description`, post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _desriptionRequest(data) {
      return {
        description: data.description,
        status: 0,
      };
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    openApprovalModal(modalName) {
      document.getElementById("data_id").value = modalName;

      this.$emit("history_approval", {
        banner: this.history_banner,
        image: this.history_image,
        description: this.history_description,
      });
    },
  },

  async mounted() {
    this.checkUserRole();
    await this.loadHistory();
  },
};
</script>

<style></style>
